import Toast from './Toast';

export default Toast;



// WEBPACK FOOTER //
// ./src/shared/components/toastMessage/index.ts